export enum StatusCreditCard {
	NAOPROCESSADO = 'NaoProcessado',
	APROVADO = 'Aprovado',
	FINALIZADO = 'Finalizado',
	RECUSADO = 'Recusado',
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/cards/credit-card-status.enum.ts